import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function CashRulesDialog({ open, onClose, groups }) {
  const [rules, setRules] = useState([]);
  const [kw, setKw] = useState("");
  const [grp, setGrp] = useState("CIG_GIDER");
  const all = { ...groups.expense, ...groups.income };
  const load = () => api.get("/cashbook/rules").then((r) => setRules(r.data));
  useEffect(() => { if (open) load(); }, [open]);

  const add = async () => {
    if (!kw.trim()) return;
    try { await api.post("/cashbook/rules", { keyword: kw.trim(), group: grp }); setKw(""); toast.success("Kural eklendi"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const del = async (id) => { await api.delete(`/cashbook/rules/${id}`); load(); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="cash-rules-dialog">
        <DialogHeader><DialogTitle className="font-heading">Otomatik Grup Kuralları</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Açıklamada bu kelime geçerse ilgili grup otomatik seçilir. Örn. "tavuk" → Çiğ Gider, "kira" → Genel Gider.</p>
        <div className="flex gap-2">
          <Input placeholder="Anahtar kelime (örn. tavuk)" value={kw} onChange={(e) => setKw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid="rule-keyword" />
          <Select value={grp} onValueChange={setGrp}>
            <SelectTrigger className="w-48" data-testid="rule-group"><SelectValue /></SelectTrigger>
            <SelectContent>{Object.entries(all).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
          </Select>
          <Button onClick={add} data-testid="rule-add" className="gap-1"><Plus className="h-4 w-4" /> Ekle</Button>
        </div>
        <div className="max-h-[50vh] overflow-y-auto space-y-4" data-testid="rules-list">
          {Object.entries(all).filter(([k]) => rules.some((r) => r.group === k)).map(([k, label]) => (
            <div key={k}>
              <div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1.5">{label}</div>
              <div className="flex flex-wrap gap-1.5">
                {rules.filter((r) => r.group === k).map((r) => (
                  <span key={r.id} className="inline-flex items-center rounded-full border border-border bg-card text-xs" data-testid={`rule-${r.id}`}>
                    <span className="px-2.5 py-1">{r.keyword}</span>
                    <button onClick={() => del(r.id)} data-testid={`rule-delete-${r.id}`} className="pr-2 text-muted-foreground/50 hover:text-destructive"><Trash2 className="h-3 w-3" /></button>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
